import React, { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import "./Statistics.css";

const Statistics: React.FC = () => {
  const [firstNumber] = useState<number>(6);
  const [secondNumber] = useState<number>(150);
  const [thirdNumber] = useState<number>(2000);
  const { t, language } = useLanguage();

  // Statistics descriptions in both languages
  const statisticsText = {
    he: {
      first:
        "6 פרוייקטים קבועים כל שנה, עם מספר דינאמי של אריזות בהתאם לתרומות. לרוב יתווספו פרוייקט או 2 כל שנה בהתאם לצורך ולתקופה",
      second:
        "אנשים נרתמים מדי שנה לעזור לארוז את החבילות עבור המשפחות. החל מתרומה כספית עבור החבילות, וממשיך בהגעה פיזית לצורך אריזת החבילות, ולסיום- הובלת החבילות ליעדן",
      third:
        "משפחות כל שנה זוכות לקבל אריזות שנותנות להן להרגיש שמישהו חשב עליהם ודייק את הצורך עבורם כדי להגיע מוכנים לתקופות חשובות כמו לימודים, חגים, ואירועים חשובים",
    },
    en: {
      first:
        "6 regular projects each year, with a dynamic number of packages based on donations. Usually, 1 or 2 additional projects are added annually depending on needs and timing.",
      second:
        "People volunteer each year to help pack packages for families. From financial donations for supplies, to physical presence for packing, and finally - delivering packages to their destinations.",
      third:
        "Families each year receive packages that make them feel someone thought about them and tailored solutions to their needs, helping them prepare for important periods like school, holidays, and special events.",
    },
  };

  return (
    <div className="statistics-container">
      <div
        className="statistics-text"
        lang={language}
        dir={language === "he" ? "rtl" : "ltr"}
      >
        {t("intro.text")}
      </div>
      <div className="numbers-container">
        <div className="stat-item">
          <span className="stat-number">{firstNumber}+</span>
          <p
            className="stat-description"
            lang={language}
            dir={language === "he" ? "rtl" : "ltr"}
          >
            {statisticsText[language].first}
          </p>
        </div>
        <div className="stat-item">
          <span className="stat-number">{secondNumber}+</span>
          <p
            className="stat-description"
            lang={language}
            dir={language === "he" ? "rtl" : "ltr"}
          >
            {statisticsText[language].second}
          </p>
        </div>
        <div className="stat-item">
          <span className="stat-number">{thirdNumber}+</span>
          <p
            className="stat-description"
            lang={language}
            dir={language === "he" ? "rtl" : "ltr"}
          >
            {statisticsText[language].third}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Statistics;
